import * as PIXI from "pixi.js";
import { EventHandler } from "../../util/event/EventHandler";
import { GraphicsUtil } from "../../util/view/GraphicsUtil";
import { MouseUtil } from "../../util/view/MouseUtil";
import { AbstractView } from "../view/AbstractView";
/**
 * MouseBlocker.ts
 */
export class MouseBlocker extends AbstractView {
    constructor(properties, portraitProperties) {
        super(properties, portraitProperties);
        this.run();
    }
    destroy() {
        super.destroy();
        this.children.forEach(child => {
            this.removeChild(child);
            child.destroy();
        });
        this.blocker = null;
    }
    create() {
        super.create();
        this.createBlocker();
        this.on("added", this.fitToWindow, this);
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.responsive = true;
    }
    createBlocker() {
        this.blocker = GraphicsUtil.createRectangle(new PIXI.Point(10, 10), this.uiProperties.colour, this.uiProperties.alpha);
        this.pivot.set(5, 5);
        if (this.uiProperties.clickToDismiss) {
            this.blocker.cursor = "pointer";
            this.clickHandler = new EventHandler(this.hide, this);
            MouseUtil.addMouseBlock(this.blocker, this.handleBlockerSelected, this);
        }
        else {
            MouseUtil.addMouseBlock(this.blocker);
        }
        this.addChild(this.blocker);
        this.fitToWindow();
    }
    fitToWindow() {
        if (this.parent) {
            const transformedScale = this.getTransformedScale(this.parent, new PIXI.Point(1, 1));
            const renderView = this.renderer.getView();
            const renderWidth = parseInt(renderView.style.width, 10) || renderView.width;
            const renderHeight = parseInt(renderView.style.height, 10) || renderView.height;
            this.width = renderWidth / transformedScale.x;
            this.height = renderHeight / transformedScale.y;
            this.position = this.parent.toLocal(new PIXI.Point(renderWidth / 2, renderHeight / 2));
        }
    }
    handleBlockerSelected(event) {
        event.stopPropagation();
        if (this.clickHandler) {
            this.clickHandler.call();
        }
    }
    onClick(handler, scope) {
        this.clickHandler = new EventHandler(handler, scope);
    }
    handleResize(event) {
        super.handleResize(event);
        this.fitToWindow();
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.uiProperties = this.uiProperties;
    }
}
//# sourceMappingURL=MouseBlocker.js.map